export default __webpack_public_path__ + "static/media/purpleArgo.e654fdd1.svg";